import { useMemo } from 'react';

type RouteOrigin = Readonly<{
  current: string;
  protocol: string;
  domain: string;
  port: string | null;
}>;

export function useUrlOriginReader(): RouteOrigin {
  return useMemo(
    () =>
      Object.freeze({
        current: window.location.origin, // "https://example.com"
        protocol: window.location.protocol, // "https:"
        domain: window.location.hostname, // "example.com"
        port: window.location.port || null, // "8080"
      }),
    []
  );
}
